import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { colors } from '../../../theme';

type FakeInputProps = {
  inputLabel: string;
  defaultValue: string;
};

const useStyles = makeStyles({
  label: {
    color: colors.silver,
    marginLeft: 10,
  },
  value: {
    color: colors.madison,
    marginLeft: 10,
    marginTop: 6,
  },
});

const FakeInput = ({
  inputLabel,
  defaultValue,
}: FakeInputProps): JSX.Element => {
  const classes = useStyles();
  return (
    <>
      <Typography
        data-testid="label"
        variant="caption"
        className={classes.label}
      >
        {inputLabel}
      </Typography>
      <Typography data-testid="value" variant="body2" className={classes.value}>
        {defaultValue}
      </Typography>
    </>
  );
};

export default FakeInput;
